function initCoaSearch() {
  const section = document.querySelector('.main-coa')
  if (!section) return

  const search = section.querySelector('.main-coa-search')
  const input = section.querySelector('.main-coa-search-input')
  const button = section.querySelector('.main-coa-search-button')
  const message = section.querySelector('.main-coa-search-message')

  if (!search || !input || !button) return

  const blogHandle = search.dataset.coaBlogHandle || 'coa'
  const errorMessage =
    search.dataset.coaErrorMessage || 'Please enter a valid product or batch number'

  function handleize(value) {
    return value
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
  }

  function articleUrl(articleHandle) {
    const root = window.Shopify?.routes?.root || '/'
    return `${root.replace(/\/$/, '')}/blogs/${blogHandle}/${articleHandle}`
  }

  function showError() {
    if (message) {
      message.textContent = errorMessage
      message.hidden = false
    }
    section.classList.add('main-coa-has-error')
  }

  function clearError() {
    if (message) {
      message.textContent = ''
      message.hidden = true
    }
    section.classList.remove('main-coa-has-error')
  }

  async function articleExists(url) {
    const response = await fetch(url, { method: 'HEAD' })
    return response.ok
  }

  async function handleSearch() {
    clearError()

    const articleHandle = handleize(input.value)
    if (!articleHandle) {
      showError()
      return
    }

    const url = articleUrl(articleHandle)

    try {
      section.classList.add('main-coa-loading')

      if (await articleExists(url)) {
        window.location.assign(url)
        return
      }

      showError()
    } catch (error) {
      console.error('[COA]', error)
      showError()
    } finally {
      section.classList.remove('main-coa-loading')
    }
  }

  button.addEventListener('click', handleSearch)

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleSearch()
    }
  })

  input.addEventListener('input', clearError)
}

initCoaSearch()
